import CrossIcon from 'assets/img/icons/cross.svg?react';
import { Box, IconButton, InputAdornment, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { AddButton, LwFormInput } from 'redesign';

export const HqUserToolbox = ({
  search,
  setParams,
}: {
  search: string | undefined;
  setParams: ({ user }: { user: string | undefined }) => void;
}) => {
  const form = useForm<{ search: string | null }>({ defaultValues: { search } });
  const { t } = useTranslation('hq-screen-specific');

  return (
    <ToolboxWrapper>
      <Box flex={1}>
        <AddButton>{t('users.toolbox.create_button')}</AddButton>
      </Box>
      <Box flex={1}>
        <LwFormInput
          name="search"
          control={form.control}
          label={t('users.toolbox.search_label')}
          placeholder={t('users.toolbox.search_placeholder')}
          onChange={(e) => {
            setParams({ user: e.target.value ?? undefined });
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label={t('users.toolbox.clear_aria_label')}
                  onClick={() => {
                    form.setValue('search', null);
                    setParams({ user: undefined });
                  }}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  <CrossIcon width={20} height={20} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </ToolboxWrapper>
  );
};

const ToolboxWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(6),
}));
